import React, { Component } from 'react';
import PropTypes from 'prop-types';
import initialize from './animation';
import { LoadingWrapper } from './styles';
import './styles.css';

// const LoadingImageStyle = {
//   backgroundImage: `url(${LoadingImageUrl})`,
// };

class Loading extends Component {
  componentDidMount() {
    initialize();
  }

  getBackgroundColor = () => {
    const { app, actualContext, color } = this.props;
    if (color) {
      return color;
    }

    if (!actualContext) {
      return app.color1;
    }
    if (actualContext.color) {
      return actualContext.color;
    }
    switch (actualContext.elementType) {
      case 'narrative':
      case 'objective':
        return actualContext.color;
      default:
        return app.color1;
    }
  }

  render() {
    const { hide, actualContext } = this.props;
    const color = this.getBackgroundColor();
    const elementType = actualContext ? actualContext.elementType : '';
    return (
      <LoadingWrapper contextType={elementType} color={color || color.color} className={hide ? 'container--loading hidden' : 'container--loading'}>
        <canvas className='canvas' />
      </LoadingWrapper>
    );
  }
}

Loading.propTypes = {
  hide: PropTypes.bool,
  actualContext: PropTypes.object,
  app: PropTypes.object,
  color: PropTypes.string,
};

Loading.defaultProps = {
  hide: true,
  actualContext: null,
  color: null,
  app: null,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.jsx